const signs = [
  "Feel air coming through closed windows",
  "Water leaks during heavy rain",
  "Visible cracks in caulking around frames",
  "High humidity inside despite AC",
  "Window rattles in strong wind",
  "Daylight visible around door edges",
];

export default function CommonIssues() {
  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            Signs You Need Weatherstripping Service
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {signs.map((s) => (
            <div
              key={s}
              className="flex items-center gap-3 bg-[#f8fafc] rounded-lg px-4 py-3"
            >
              <i className="ri-checkbox-circle-fill text-primary text-lg shrink-0" />
              <span className="text-sm md:text-base text-secondary">{s}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}